import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OSService, TecnicoService } from 'src/app/services';
import { IParceiro } from 'src/app/services/parceiro';

@Component({
  selector: 'app-parceiro',
  templateUrl: './parceiro.component.html',
  styleUrls: ['./parceiro.component.scss']
})
export class ParceiroComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  parceiros: IParceiro[];
  encaminhaParceiroForm: FormGroup;
  labelBotao: string = 'Encaminhar';

  constructor(
    private fb: FormBuilder,
    private tecnicoService: TecnicoService,
    private osService: OSService
  ) {}

  ngOnInit(): void {
    this.getParceiros();
    this.encaminhaParceiroForm = this.fb.group({
      parceiro: ['']
    });
  }

  getParceiros() {
    this.subscriptions$.add(
      this.tecnicoService.getTecnico().subscribe({
        next: (response) => {
          this.parceiros = response.data;
        }
      })
    );
  }

  doEncaminhar() {
    const parceiroOs = {
      codigoOS: '000031',
      codTec: this.encaminhaParceiroForm.getRawValue().parceiro
    };

    this.subscriptions$.add(
      this.osService.postOSParceiro(parceiroOs).subscribe({
        complete: () => {}
      })
    );
  }

  isButtonEnabled(): boolean {
    return !!this.encaminhaParceiroForm.getRawValue().parceiro;
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
